// src/components/account/AccountPluginItemSkeleton.tsx

export function AccountPluginItemSkeleton() {
    return (
        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow-subtle relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-100/50 to-transparent animate-shimmer"></div>
            <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gray-200 rounded-md"></div>
                <div>
                    <div className="h-5 w-40 bg-gray-200 rounded mb-2"></div>
                    <div className="h-4 w-24 bg-gray-200 rounded"></div>
                </div>
            </div>
            <div className="h-10 w-28 bg-gray-200 rounded-lg"></div>
        </div>
    );
}